import { useState } from 'react'
import type { FC, PropsWithChildren } from 'react'
import { Map, NavigationControl } from 'react-map-gl'
import { Box, ChakraProps } from '@chakra-ui/react'

type MapProps = {
	latitude: number
	longitude: number
}

const InteractiveMap: FC<PropsWithChildren & MapProps & ChakraProps> = ({
	children,
	latitude,
	longitude,
	...rest
}) => {
	const [viewport, setViewport] = useState({
		latitude,
		longitude,
		zoom: 16,
	})
	return (
		<Box
			position="relative"
			h={{ base: 64, md: 80, lg: 96 }}
			w="100%"
			{...rest}
		>
			<Map
				{...viewport}
				onMove={(event) => setViewport(event.viewState)}
				mapStyle="mapbox://styles/mapbox/light-v9"
				mapboxAccessToken={import.meta.env.VITE_MAPBOX_TOKEN}
				scrollZoom={false}
			>
				<NavigationControl position="bottom-right" showCompass={false} />
				{children}
			</Map>
		</Box>
	)
}

export default InteractiveMap
